export default {
  FUZZY: 'ctrl+z',
  BIONIC: 'ctrl+b',
}
